import { render, staticRenderFns } from "./EditionCantons.vue?vue&type=template&id=bca6e27c&scoped=true"
import script from "./EditionCantons.vue?vue&type=script&lang=js"
export * from "./EditionCantons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca6e27c",
  null
  
)

export default component.exports